import {HRParamType} from "./HRParamType";

export class HRConfigParam {
  id:                   string;
  hrConfigId:           string;
  ownerEmployeeId:      string;
  paramType =      HRParamType.CATEGORY;
  value:                string;
  displayOrder:         number;

  _createSpecialElement(propertyName: string, data: any) {
    if ('paramType' === propertyName) {
      this.paramType = HRParamType.retrieveFromCode(data);
      return true;
    }

    return false;
  }
}
